import { ColorDynamic } from '@superdispatch/ui';
import { ReactNode } from 'react';
import { getInitialSource } from 'shared/helpers/Analytics';
import { WebviewLayout } from 'shared/layout/WebviewLayout';

export function isRedirectFromLoadboard() {
  const source = getInitialSource();
  return source === 'Mobile SLB';
}

interface CarrierWebviewHeaderProps {
  children: ReactNode;
}

export function CarrierWebviewHeader({ children }: CarrierWebviewHeaderProps) {
  return (
    <WebviewLayout scrollable={false} backgroundColor={ColorDynamic.White}>
      {children}
    </WebviewLayout>
  );
}
